import React, { useCallback, useEffect, useState } from 'react';
import socket from '../socket';
import useSocketEvent from '../utils/useSocketEvent';
import { loadActiveShow, loadShowFinale } from '../integrations/quizApiAdapter';
import FinaleDecoderView from './FinaleDecoderView';
import FinaleQuizpokerView from './FinaleQuizpokerView';
import FinaleFinalfrageView from './FinaleFinalfrageView';

// Generischer Finale-Bereich: rendert je nach kind der aktiven Show die
// passende Regie+Edit-Seite (Decoder oder Quizpoker).
function FinaleView() {
    const [kind, setKind] = useState(null);
    const [playsetId, setPlaysetId] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadKind = useCallback(async () => {
        setLoading(true);
        try {
            const active = await loadActiveShow();
            const pid = active?.playsetId ?? null;
            setPlaysetId(pid);
            if (pid) {
                const finale = await loadShowFinale(pid).catch(() => null);
                setKind(finale?.kind || 'decoder');
            } else {
                setKind('decoder');
            }
        } catch (err) {
            setKind('decoder');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadKind();
    }, [loadKind]);

    useSocketEvent(socket, 'show:active', loadKind);

    if (loading) {
        return <div className="page text-muted">Finale wird geladen…</div>;
    }
    if (kind === 'quizpoker') {
        return <FinaleQuizpokerView playsetId={playsetId} />;
    }
    if (kind === 'finalfrage') {
        return <FinaleFinalfrageView playsetId={playsetId} />;
    }
    return <FinaleDecoderView />;
}

export default FinaleView;
